import alerts from './plugins/alerts'
import App from './App.vue'
import auth from './plugins/auth'
import dropDown from './plugins/dropdown'
import DatePicker from './plugins/datepicker'
import files from './plugins/files'
import filters from './plugins/filters'
import i18n from './plugins/languages/i18n'
import modal from './plugins/modal'
import OrganismTheHeader from './components/organisms/OrganismTheHeader'
import router from './router'
import services from './plugins/services'
import store from './store'
import utils from './plugins/utils'
import validation from './plugins/validation'
import Vue from 'vue'
import Vuelidate from 'vuelidate'

// Registración global de todos los componentes atoms
const requireComponent = require.context(
  './components',
  true,
  /Atom[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)

  Vue.component(
    fileName.replace('./atoms/', '').replace('.vue', ''),
    componentConfig.default || componentConfig
  )
})

// Registración global del componente DatePicker
Vue.component('DatePicker', DatePicker)

// Registración global del componente único TheHeader
Vue.component('OrganismTheHeader', OrganismTheHeader)

// Carga del módulo de moment
const moment = require('moment')
require('moment/locale/es')

// Registración global de plugins
Vue.use(alerts)
Vue.use(auth)
Vue.use(dropDown)
Vue.use(files)
Vue.use(filters)
Vue.use(modal)
Vue.use(require('vue-moment'), { moment })
Vue.use(services)
Vue.use(utils)
Vue.use(validation)
Vue.use(Vuelidate)

Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
